import { createContext, useContext, useEffect, useState } from 'react';
import { api } from '../api.js';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [staff, setStaff] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('staff_token');
    if (!token) {
      setLoading(false);
      return;
    }
    api
      .get('/me')
      .then(({ data }) => setStaff(data.staff))
      .catch(() => localStorage.removeItem('staff_token'))
      .finally(() => setLoading(false));
  }, []);

  function login(token, staffData) {
    localStorage.setItem('staff_token', token);
    setStaff(staffData);
  }

  function logout() {
    localStorage.removeItem('staff_token');
    setStaff(null);
  }

  return <AuthContext.Provider value={{ staff, loading, login, logout }}>{children}</AuthContext.Provider>;
}

export function useAuth() {
  return useContext(AuthContext);
}
